<route>
{
    "name": "reports-account-transaction-report",
    "meta": {
        "title": "Raport tranzactii conturi",
        "requiresAuth": true,
        "permissions": ["manager", "sef_de_unitate", "secretar"],
        "fail": "/403"
    }
}
</route>
<template>
    <company-layout>
        <v-container fluid grid-list-xl>
            <v-row>
                <v-col>
                    <v-card :loading="loading">
                        <template slot="progress">
                            <v-overlay absolute class="d-flex flex-column text-center">
                                <div>
                                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                                        <span>In curs de incarcare...</span>
                                    </v-progress-circular>
                                </div>
                            </v-overlay>
                        </template>
                        <v-card-title>
                            Raport conturi
                            <v-spacer></v-spacer>
                            <v-select
                                :items="Static.accounts"
                                item-text="name"
                                item-value="id"
                                v-model="account"
                                :style="{maxWidth:'300px', maxHeight: '40px'}"
                                placeholder="Cont"
                                label="Cont"
                                class="primary--text"
                                name="account"
                                clearable
                                solo
                                dense
                            ></v-select>
                            <v-menu
                                ref="menu"
                                v-model="periodMenu"
                                :close-on-content-click="false"
                                :return-value.sync="period"
                                transition="scale-transition"
                                offset-y
                                class="py-0"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        v-bind="attrs"
                                        v-on="on">
                                        Perioada {{ periodText }}
                                    </v-btn>
                                </template>
                                <v-date-picker
                                    v-model.lazy="period"
                                    range
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="periodMenu = false"
                                    >
                                        Anulare
                                    </v-btn>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.menu.save(period)"
                                    >
                                        Filtrare
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-simple-table dense>
                                        <template v-slot:default>
                                            <thead>
                                            <tr>
                                                <th class="text-left">
                                                    Sursa
                                                </th>
                                                <th class="text-left">
                                                    Destinatie
                                                </th>
                                                <th class="text-right">
                                                    Valoare
                                                </th>
                                                <th class="text-right">
                                                    Metoda de plata
                                                </th>
                                                <th class="text-right">
                                                    Descriere
                                                </th>
                                                <th class="text-right">
                                                    Data
                                                </th>
                                                <th class="text-right">
                                                    Adaugat de
                                                </th>
                                                <th class="text-right">
                                                    Actiuni
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <template v-for="(item, index) in paymentTransactions">
                                                <tr :key="index">
                                                    <td>
                                                        <payment-transaction-source :item="item"></payment-transaction-source>
                                                    </td>
                                                    <td>
                                                        <payment-transaction-destination :item="item"></payment-transaction-destination>
                                                    </td>
                                                    <td class="text-right">
                                                        {{ item.amount | price }}
                                                    </td>
                                                    <td class="text-right">
                                                        {{ _.get(paymentTypes, _.get(item, 'payment.method', '-'), 'Nedefinit') }}<br/>
                                                    </td>
                                                    <td class="text-right">
                                                        Numar document: {{ _.get(item, 'payment.document_no', 'Nedefinit') }}<br/>
                                                        Plata #{{ _.get(item, 'payment.id', 'Nedefinit') }}<br/>
                                                    </td>
                                                    <td class="text-right">
                                                        <template v-if="!_.isNil(item.payment.payment_date)">
                                                        {{ new Date(item.payment.payment_date) | date }}
                                                        </template>
                                                        <template v-else>
                                                            -
                                                        </template>
                                                    </td>
                                                    <td class="text-right">
                                                        {{ _.get(users.find(user => user.id === item.payment.created_by), 'name', `Necunoscut (${item.payment.created_by})`) }}
                                                    </td>
                                                    <td class="text-right">
                                                        <v-icon
                                                            small
                                                            class="mr-2"
                                                            @click="showIndex === index ? showIndex = undefined : showIndex = index"
                                                        >
                                                            mdi-eye
                                                        </v-icon>
                                                    </td>
                                                </tr>
                                                <tr v-if="showIndex === index">
                                                    <td colspan="8">
                                                        <pre>
                                                            {{ item }}
                                                        </pre>
                                                    </td>
                                                </tr>
                                            </template>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </company-layout>
</template>

<script>
    import CompanyLayout from "Layouts/Company.vue";
    import PaymentTransactionSource from "Components/reports/Common/PaymentTransactionSource.vue";
    import PaymentTransactionDestination from "Components/reports/Common/PaymentTransactionDestination.vue";

    export default {
        components: {
            CompanyLayout,
            PaymentTransactionSource,
            PaymentTransactionDestination
        },
        data () {
            return {
                loading: true,
                period: [window.moment().subtract(1, 'month').toISOString(), window.moment().toISOString()],
                periodMenu: false,
                paymentTransactions: [],
                account: undefined,
                showIndex: undefined,
                users: []
            }
        },
        computed: {
            periodText () {
                return this.period.map(item => this.$options.filters.date(new Date(item))).join(' ~ ')
            },
            paymentTypes () {
                let types = (new this.$db.Payment).types
                return types.reduce((total, item) => {
                    total[item.handle] = item.name
                    return total
                }, {})
            }
        },
        watch: {
            period: {
                async handler(val) {
                    await this.fetchData()
                }
            },
            account: {
                async handler(val) {
                    await this.fetchData()
                }
            }
        },
        async mounted() {
            await this.loadEmployees()
            await this.fetchData()
        },
        methods: {
            async fetchData () {
                if(this.period.length !== 2) return
                this.loading = true
                var paymentTransactions = this.$db.PaymentTransaction
                    .include(
                        'payment',
                        'payment.accountable.customer',
                        'payment.subject',
                        'payment.payer'
                    )
                    .where('between', [window.moment(this.period[0]).format('YYYY-MM-DD'), window.moment(this.period[1]).format('YYYY-MM-DD')].join(','))

                if(this.account !== undefined) {
                    paymentTransactions = paymentTransactions.where('account_involved', this.account)
                }

                await paymentTransactions
                    .limit(2500)
                    .get()
                    .then(({data}) => {
                        this.paymentTransactions = data.sort(function(a, b) {
                            return new Date(b?.payment?.payment_date) - new Date(a?.payment?.payment_date);
                        })
                    }).catch((err) => {
                        console.error(err)
                    }).finally(() => {
                        this.loading = false
                    })
            },

            async loadEmployees () {
                let { data, meta } = await this.$db.Employee
                    .where('active', true)
                    .page(1)
                    .limit(500)
                    .get()
                this.users = data.sort(function(a, b) {
                    var nameA = a.name.toUpperCase();
                    var nameB = b.name.toUpperCase();
                    return (nameA < nameB) ? -1 : (nameA > nameB) ? 1 : 0;
                });
            }
        }
    };
</script>
